// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"da7198bb","84":"8b6135a2","164":"f817cfda","184":"47f955d3","308":"1eb5ddb6","320":"65b697c8","516":"42dee27d","568":"e3a128b8","736":"91214d1f","808":"3595f311","848":"7b170ecd"}[chunkId] + ".chunk.js";
};